import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20f481a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-20f481a8>举报须知</div><div class=\"main-content\" data-v-20f481a8><div class=\"main-title first-main-title\" data-v-20f481a8>举报机制</div><div class=\"text\" data-v-20f481a8> 极飞科技监察委员会为对极飞科技员工违法、违规行为的举报受理机构，受理关于极飞科技员工涉嫌贪污、行贿、受贿、舞弊等任何违法、违规或者不正当的行为。您可以通过本须知内的方式进行举报，举报时请尽量提供相关证据，以便我们开展后续的调查核实工作。 </div><div class=\"main-title\" data-v-20f481a8>举报人信息保密承诺</div><div class=\"text\" data-v-20f481a8><div data-v-20f481a8> 1. 对举报人及所提供的举报内容严格保密。除法律另有规定外，未经举报人许可，不会将举报人的相关信息泄露给被举报人或其他第三方。 </div><div data-v-20f481a8>2. 不强制要求举报人进行实名举报，且调查过程中不会强制要求与举报人当面沟通。</div><div data-v-20f481a8><div data-v-20f481a8>3. 对于主动提供举报信息并积极配合相关调查的商业伙伴，提供如下保障：</div><ol class=\"block\" data-v-20f481a8><li data-v-20f481a8> （1）对于已经建立合作关系的，将继续保持合作，同时不予追究其涉及举报内容相关的违约责任。 </li><li data-v-20f481a8>（2）对于意向建立合作关系的，根据其资质等方面情况，保留优先合作机会。</li><li data-v-20f481a8>（3）对于符合我司举报规定的线索提供人，将予以奖励。</li></ol></div><div data-v-20f481a8><div data-v-20f481a8> 4. 严禁公司员工以任何形式对举报人和其他提供线索人员进行打击报复，违者将从严从重处理，违法犯罪的将追究法律责任。 </div></div><div data-v-20f481a8>5.举报人应当基于其所了解的客观事实进行举报，但不得恶意捏造、编造不实内容。</div></div><div class=\"main-title\" data-v-20f481a8>举报方式</div><div class=\"text\" data-v-20f481a8><div data-v-20f481a8>举报人可通过以下任一方式进行举报：</div><div data-v-20f481a8>1、电子邮箱：jiancha@xa.com</div><div data-v-20f481a8>2、通讯地址：中国广东省广州市天河区高普路115号 极飞科技监察委员会</div><div data-v-20f481a8>3、微信公众号：“极飞科技”公众号页面左下角：关于极飞—监督举报—我要举报</div><div data-v-20f481a8>4、极飞科技官网：官网主页—关于极飞—监督举报—我要举报</div></div></div>", 2)


import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'notice-on-reporting',
  emits: ['close'],
  setup(__props, { emit: emits }) {


function closeHandle() {
  emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(CommonFooterNextButton, {
      title: "我已知晓",
      fullBtn: "",
      class: "footer-button-item",
      onClick: closeHandle
    })
  ]))
}
}

})